import { Injectable } from '@angular/core';
import { DatasourceTableJobQuery } from '@y42/datasource';
import { DateTimeService } from '@y42/date-time';
import { OrgUserQuery } from '@y42/org-user/state';
import { UiModelingTableStoreQuery } from '../datasource-table/ui-modeling-table.store-query';
import { UiModelingStoreQuery } from '../datasource/ui-modeling.store-query';
import { UiModelingJobSettingsValidationService } from './ui-modeling-job-settings-validation/ui-modeling-job-settings-validation.service';
import { UiModelingTableJobStore } from './ui-modeling-table-job.store';

@Injectable({ providedIn: 'root' })
export class UiModelingTableJobQuery extends DatasourceTableJobQuery {
  constructor(
    store: UiModelingTableJobStore,
    dateTimeService: DateTimeService,
    grandParentQuery: UiModelingStoreQuery,
    parentQuery: UiModelingTableStoreQuery,
    orgUserQuery: OrgUserQuery,
    jobSettingsValidationService: UiModelingJobSettingsValidationService,
  ) {
    super(store, dateTimeService, grandParentQuery, parentQuery, orgUserQuery, jobSettingsValidationService);
  }
}
